module.exports = __webpack_public_path__ + "static/img/ic_delivery.61779a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/pc/ic_delivery.png
// module id = Zg58
// module chunks = 10